import { services } from '../../../services/services';
import { SlotSource } from '../AppointmentBookingForm/SlotPicker';

/**
 * `SlotPicker`'s two reads, for somebody with no session: the same questions asked of the
 * clinic the hostname names. The window length the picker passes is ignored -- the API sizes
 * the windows from the service, so a visitor cannot ask for a shorter hour than it sells.
 */
export const publicSlotSource = (hostname: string, serviceId: number): SlotSource => ({
    slots: (from: string, to: string, _windowLength: number, therapistId: number) =>
        services.publicBooking.getSlots(hostname, serviceId, therapistId, from, to),
    program: (therapistId: number) => services.publicBooking.getProgram(hostname, therapistId),
});
